import {
  Typography,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Chip,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FunctionComponent, SVGProps } from 'react';

type FeatureItemProps = {
  label: string;
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  comingSoon?: boolean;
};

export const FeatureItem = (props: FeatureItemProps): JSX.Element => {
  const { label, Icon, comingSoon } = props;
  const { t } = useTranslation();

  return (
    <ListItem disableGutters>
      <ListItemIcon
        sx={{
          width: 32,
          height: 32,
          minWidth: 32,
          mr: 1,
        }}
      >
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: 'background.membership',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            color: 'text.primary',
            '& svg': {
              width: 32,
              height: 32,
            },
          }}
        >
          <Icon aria-hidden />
        </Box>
      </ListItemIcon>
      <ListItemText
        primary={
          comingSoon ? (
            <Stack
              direction="row"
              sx={{
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
              spacing={1}
            >
              <Typography variant="body2">{label}</Typography>
              <Chip
                label={t('supportUs.comingSoon')}
                color="brand"
                component="span"
                variant="watchduty"
              />
            </Stack>
          ) : (
            <Typography variant="body2">{label}</Typography>
          )
        }
        sx={{ margin: 0 }}
      />
    </ListItem>
  );
};
